
export function toIDR(number, akhiran="_"){
   if(isNaN(number)) return 'Rp 0'

   return new Intl.NumberFormat('id',{ 
            style: 'currency',
            currency: 'IDR' 
         })
         .format(number)
}


// WEBPACK FOOTER //
// ./src/_utils/tocurrency.js